import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../common/types/paginationType';
import dialog from '../../common/utility/dialog';
import global from '../../common/utility/global';
import estadoMock from '../../common/mock/estadoMock';

import parametroService from '../../service/integracion/parametroService';

import Header from '../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            filter: {
                nombreParametro: "",
                valor: "",
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombreParametro: "",
            valor: "",
        }
    };

    handleClearFilters = () => {
        var filter = {
            nombreParametro: "",
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    /******************** FORM MODAL *****************/

    handleEdit = async (values) => {
        
        const response = await parametroService.obtenerEmpresaParametroPorId(values.id);
        if (response !== undefined) {
            this.setState({
                visible: true,
                formValues: {
                    id: response.id,
                    nombreParametro: response.nombreParametro,
                    valor: response.valor
                }
            });
        }
    };

    handleSave = (values, form) => {
        
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response = await parametroService.modificarEmpresaParametro(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false});
                message.success('Modificado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleSaveGrilla = (values) => {
        
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response = await parametroService.modificarEmpresaParametro(values);
            this._handlePagination(this.state.filter);
            if (response.status === 200) {
                message.success('Modificado correctamente.');
                return;
            }
            
            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        }, () => {
            window.location.reload(false); 
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, parametroService.paginacionEmpresaParametro);
        this.setState({loadingSource: false });
    }

    render() {
        return (
            <div>
                <Header
                    title="Parametros"
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    // onEdit={this.handleEdit}
                    onChange={this._handleChangePagination}
                    onSave={this.handleSaveGrilla}
                />
                {/* <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                /> */}
            </div>
        );
    };
}